import request from 'local_modules/request'
import { reducers } from 'redux/core'
import { constants } from 'helpers'
import moment from 'moment'
import { getImageLink } from 'voting/helpers'


const setFetching = (isFetching) => reducers.voting.adminPage.setFetching(isFetching)

const fetchPolls = () => {
  return request.get(constants.voting.getPoll)
    .then(({ data }) => data)
    .then((poll) => reducers.voting.adminPage.setPolls(poll))
    .catch((error) => {
      console.log({ error })
    })
}

//  getShortNews: `${apiUrl}/getShortNews`, // ?type=1&offset=0&limit=20
// const fetchNewsList = ({ offset = 0, limit = 20 }) => {
//   return request.get(constants.voting.getShortNews + `?offset=${offset}&limit=${limit}`)
//     .then(({ data }) => data)
//     .then((newsList) => {
//       reducers.voting.adminPage.setNewsList(newsList)
//     })
//     .catch((error) => {
//       console.log({ error, offset, limit })
//     })
// }

// getNews: `/getNews`, // ?id=34610
// const fetchNews = (id) => {
//   return request.get(constants.voting.getNews + `?id=${id}`)
//     .then(({ data }) => data)
//     .then((news) => {
//       reducers.voting.adminPage.setNews({ id, news })
//
//       return news
//     })
//     .catch((error) => {
//       console.log({ error, id })
//     })
// }

const fetchTags = () => {
  return request.get(constants.voting.getTags)
    .then(({ data }) => data)
    .then((tags) => {
      reducers.voting.adminPage.setTags(tags)
    })
    .catch((error) => {
      console.log(error)
    })
}

// const removeNews = (id) => {
//   return request.get(constants.voting.deleteNews + `?id=${id}`)
//     .then(({ data }) => data)
//     .then((data) => {
//       console.log({ data })
//       reducers.voting.adminPage.removeNews(id)
//
//       return body
//     })
//     .catch((error) => {
//       console.log({ error, id })
//     })
// }

const sendFile = (file) => {
  return request.post(constants.voting.setImage + '?saveVariant=true', file)
    .then(({ data }) => data)
    .catch((error) => {
      console.log('Error sumbit file', error)
    })
}

const sendPoll = ({ image, ...data }) => {
  const startDate = moment(data.startDate, 'DDMMYYYY').format('DD.MM.YYYY')
  const endDate   = moment(data.endDate, 'DDMMYYYY').format('DD.MM.YYYY')

  const promise = () => image ? sendFile(image) : Promise.resolve({ uuid: data.imageUuid })

  return promise()
    .then(({ uuid }) => (
      request.post(constants.voting.setPoll, {
        ...data,
        startDate,
        endDate,
        imageUuid: uuid,
      })
        .then(({ data }) => data)
        .catch((error) => {
          console.log(error)
        })
    ))
}

const editPoll = ({ id, image, ...data }) => {
  const startDate = moment(data.startDate, 'DDMMYYYY').format('DD.MM.YYYY')
  const endDate   = moment(data.endDate, 'DDMMYYYY').format('DD.MM.YYYY')

  const promise = () => image ? sendFile(image) : Promise.resolve({ uuid: data.imageUuid })

  return promise()
    .then(({ uuid }) => (
      request.put(constants.voting.setPoll + `/${id}`, {
        id,
        ...data,
        startDate,
        endDate,
        imageUuid: uuid,
      })
        .then(({ data }) => data)
        .catch((error) => {
          console.log(error)
        })
    ))
}

const removePoll = (id) => {
  return request.delete(constants.voting.setPoll + `/${id}`)
    .then(({ data }) => data)
    .catch((error) => {
      console.log(error)
    })
}

const sendQuestions = ({ pollId, questions }) => {
  return request.post(constants.voting.setQuestions + `/${pollId}`, questions)
    .then(({ data }) => data)
    .catch((error) => {
      console.log(error)
    })
}

const sendQuestion = ({ id, pollId, title, subTitle, shortDescription, description }) => {
  if (id) {
    return request.put(constants.voting.setQuestion + `/${id}`, {
      id,
      pollId,
      title,
      subTitle,
      shortDescription,
      description
    })
      .then(({ data }) => data)
      .catch((error) => {
        console.log(error)
      })
  }

  return request.post(constants.voting.setQuestion, {
    id,
    pollId,
    title,
    subTitle,
    shortDescription,
    description
  })
    .then(({ data }) => data)
    .catch((error) => {
      console.log(error)
    })
}

const removeQuestion = (id) => {
  return request.delete(constants.voting.setQuestion + `/${id}`)
    .then(({ data }) => data)
    .catch((error) => {
      console.log(error)
    })
}

const sendAnswer = ({ id, pollId, questionId, title }) => {
  if (id) {
    return request.put(constants.voting.setAnswer + `/${id}`, {
      id,
      pollId,
      questionId,
      title,
    })
      .then(({data}) => data)
      .catch((error) => {
        console.log(error)
      })
  }

  return request.post(constants.voting.setAnswer, {
    pollId,
    questionId,
    title,
  })
    .then(({ data }) => data)
    .catch((error) => {
      console.log(error)
    })
}

const removeAnswer = (id) => {
  return request.delete(constants.voting.setAnswer + `/${id}`)
    .then(({ data }) => data)
    .catch((error) => {
      console.log(error)
    })
}


export default {
  setFetching,
  fetchPolls,
  sendPoll,
  removePoll,
  editPoll,
  sendQuestion,
  removeQuestion,
  sendAnswer,
  removeAnswer,
  sendQuestions,

  fetchTags,
}
